export const PROMPTING_EXERCISE = 'PromptingExercise';
export const EXPORTED_EXERCISES = [PROMPTING_EXERCISE];